import { __decorate, __metadata } from "tslib";
import { Component, Model, Prop, Ref } from "vue-property-decorator";
import LvField from "../field/LvField.vue";
import LvControlPopover from "../control-popover/LvControlPopover.vue";
import LvTag from "../tag/LvTag.vue";
import LvIcon from "../icon/LvIcon.vue";
import { UIComponent } from "../UIComponent";
function defaultValueMapper(value) {
    return value;
}
function defaultLabelMapper(value) {
    return value?.toString();
}
function normalizeString(value) {
    return value.trim().toLowerCase();
}
export const COMPONENT_NAME = "LvSelect";
let LvSelect = class LvSelect extends UIComponent {
    constructor() {
        super(...arguments);
        this.userInput = "";
        this.searchCriteria = null;
    }
    get model() {
        return this.value;
    }
    set model(value) {
        this.$emit("change", value);
    }
    get filteredItems() {
        if (!this.searchCriteria)
            return this.items;
        return this.items.filter(x => normalizeString(this.mapLabel(x)).includes(this.searchCriteria));
    }
    get selectedItems() {
        const values = (this.model == null ? [] :
            this.multiple && this.model instanceof Array ? this.model :
                [this.model]);
        const equalityComparer = this.getEqualityComparer();
        const selectedItems = [];
        for (const value of values) {
            const idx = this.items.findIndex(listItem => equalityComparer(value, listItem));
            if (idx > -1) {
                const listItem = this.items[idx];
                selectedItems.push(listItem);
            }
        }
        return selectedItems;
    }
    get isEmpty() {
        if (this.model == null)
            return true;
        else if (this.model instanceof Array && this.model.length == 0)
            return true;
        else
            return false;
    }
    get displayedPlaceholder() {
        if (this.isEmpty) {
            return this.placeholder;
        }
        else
            return null;
    }
    getEqualityComparer() {
        const equalityComparer = this.equalityComparer ?? ((selectedValue, listItem) => selectedValue == this.mapValue(listItem));
        return equalityComparer;
    }
    onUserInputChange() {
        this.searchCriteria = normalizeString(this.userInput);
        if (!this.userInput) {
            this.$emit("change", null);
        }
    }
    onUserInputKeyPress(ev) {
        switch (ev.code) {
            case "Backspace":
            case "Delete": {
                if (!this.userInput) {
                    this.reset();
                }
                return;
            }
            default:
                return;
        }
    }
    onUserInputFocus() {
        this.popover.show();
    }
    select(item) {
        if (this.multiple) {
            this.model = [
                ...this.model,
                this.mapValue(item),
            ];
        }
        else {
            this.model = this.mapValue(item);
            this.popover.hide();
        }
        this.resetUserInput();
        this.resetSearchCriteria();
    }
    unselect(item) {
        const equalityComparer = this.getEqualityComparer();
        if (this.multiple) {
            const selected = [...this.model];
            const toRemoveIdx = selected.findIndex(selectedValue => equalityComparer(selectedValue, item));
            if (toRemoveIdx > -1) {
                selected.splice(toRemoveIdx, 1);
                this.model = selected;
            }
        }
        else {
            this.model = null;
        }
    }
    reset() {
        if (this.multiple)
            this.model = [];
        else
            this.model = null;
        this.resetUserInput();
        this.resetSearchCriteria();
    }
    resetSearchCriteria() {
        this.searchCriteria = null;
    }
    resetUserInput() {
        this.userInput = "";
    }
};
__decorate([
    Prop({ type: Array, required: false, default: () => [] }),
    __metadata("design:type", Array)
], LvSelect.prototype, "items", void 0);
__decorate([
    Prop({ type: Function, required: false, default: defaultLabelMapper }),
    __metadata("design:type", Function)
], LvSelect.prototype, "mapLabel", void 0);
__decorate([
    Prop({ type: Function, required: false, default: defaultValueMapper }),
    __metadata("design:type", Function)
], LvSelect.prototype, "mapValue", void 0);
__decorate([
    Prop({ type: Function, required: false, default: null }),
    __metadata("design:type", Function)
], LvSelect.prototype, "equalityComparer", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: () => false }),
    __metadata("design:type", Boolean)
], LvSelect.prototype, "multiple", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvSelect.prototype, "placeholder", void 0);
__decorate([
    Model("change", { default: null }),
    __metadata("design:type", Object)
], LvSelect.prototype, "value", void 0);
__decorate([
    Ref(),
    __metadata("design:type", LvControlPopover)
], LvSelect.prototype, "popover", void 0);
LvSelect = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvIcon, LvTag, LvControlPopover, LvField },
    })
], LvSelect);
export default LvSelect;
//# sourceMappingURL=script.js.map